export default () => ({

    show: false,

    init(){

        var body = document.body,
        html = document.documentElement;

        var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        
        if(height > 3000){
            this.show = true;
        }
    }
    
});